export default __webpack_public_path__ + "fonts/inter-latin-400-normal.513f22e166bab984fa60.woff";